(function () {
  'use strict';

  var selectedQty = 5;
  var sizeValues = { S: 0, M: 0, L: 0, XL: 0, XXL: 0, '3XL': 0 };
  var uploadedFiles = { 'Chest Logo': '', 'Back Logo': '' };

  function g(id) { return document.getElementById(id); }
  function alloc() {
    return Object.values(sizeValues).reduce(function (a, b) { return a + b; }, 0);
  }

  function formatMoney(cents, format) {
    if (!format) format = 'Rs. {{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal   = decimal   == null ? '.' : decimal;
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2  = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var value = '';
    var match = format.match(placeholderRegex);
    if (!match) return format;
    switch (match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function updateTotalPrice(n) {
    var totalEl = g('cc-total-price');
    if (!totalEl) return;
    var data = window.ccProductData;
    if (!data || !data.price) { totalEl.textContent = '-'; return; }
    totalEl.textContent = formatMoney(data.price * n, data.moneyFormat);
  }

  function syncQty(n) {
    var inp = document.querySelector('.quantity__input[name="quantity"]');
    if (!inp) return;
    try {
      Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set.call(inp, n);
    } catch(e) { inp.value = n; }
    inp.dispatchEvent(new Event('input',  { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
    updateTotalPrice(n);
  }

  function hideNative() {
    var qi = document.querySelector('quantity-input.quantity'); if (qi) qi.style.display = 'none';
    var ql = document.querySelector('label.quantity__label');   if (ql) ql.style.display = 'none';
    var qr = document.querySelector('.quantity__rules');        if (qr) qr.style.display = 'none';
  }

  function setCart(on) {
    var b = document.querySelector('button[name="add"]');
    if (b) { b.disabled = !on; b.style.opacity = on ? '1' : '0.45'; b.style.cursor = on ? '' : 'not-allowed'; }
    document.querySelectorAll('.shopify-payment-button__button').forEach(function (b) {
      b.disabled = !on; b.style.opacity = on ? '1' : '0.45'; b.style.pointerEvents = on ? '' : 'none';
    });
  }

  function buildProperties() {
    // Build size distribution string
    var parts = [];
    Object.keys(sizeValues).forEach(function (k) { if (sizeValues[k] > 0) parts.push(k + ': ' + sizeValues[k]); });
    var props = {
      'Size Distribution': parts.length ? parts.join(', ') : 'Not specified',
      '_uid': Date.now().toString()
    };
    // Back text
    var bt = g('cc-back-text-input');
    if (bt && bt.value.trim()) props['Back Text'] = bt.value.trim();
    // Logos
    if (uploadedFiles['Chest Logo']) props['Chest Logo'] = uploadedFiles['Chest Logo'];
    if (uploadedFiles['Back Logo'])  props['Back Logo']  = uploadedFiles['Back Logo'];
    return props;
  }

  function update() {
    var a = alloc(), r = selectedQty - a;
    var pct = selectedQty > 0 ? Math.min(a / selectedQty * 100, 100) : 0;
    if (g('cc-allocated'))     g('cc-allocated').textContent     = a;
    if (g('cc-remaining'))     g('cc-remaining').textContent     = Math.max(r, 0);
    if (g('cc-total-display')) g('cc-total-display').textContent = selectedQty;
    var fill = g('cc-allocation-fill');
    if (fill) {
      fill.style.width = pct + '%';
      fill.className = 'cc-allocation-fill' +
        (a === selectedQty ? ' cc-allocation-fill--complete' : a > selectedQty ? ' cc-allocation-fill--over' : '');
    }
    var cc = g('corporate-customizer');
    if (cc) {
      cc.querySelectorAll('.cc-step-plus').forEach(function (b)  { b.disabled = r <= 0; });
      cc.querySelectorAll('.cc-step-minus').forEach(function (b) { b.disabled = sizeValues[b.dataset.size] <= 0; });
    }
    var vm = g('cc-validation-msg');
    if (vm) {
      vm.className = 'cc-validation-msg';
      if (a === 0)              { vm.textContent = ''; setCart(false); }
      else if (a < selectedQty) { vm.classList.add('cc-validation-msg--error'); vm.textContent = 'Allocate ' + r + ' more piece(s) across sizes.'; setCart(false); }
      else if (a > selectedQty) { vm.classList.add('cc-validation-msg--error'); vm.textContent = 'Allocated ' + (a - selectedQty) + ' too many. Please reduce.'; setCart(false); }
      else                      { vm.classList.add('cc-validation-msg--success'); vm.textContent = '✓ Size allocation complete!'; setCart(true); }
    }
  }

  function selQty(n) {
    if (n < 5 || n % 5 !== 0) return;
    selectedQty = n;
    document.querySelectorAll('.cc-qty-pill').forEach(function (p) {
      p.classList.toggle('cc-qty-pill--active', parseInt(p.dataset.qty) === n);
    });
    syncQty(n);
    if (alloc() > selectedQty) {
      Object.keys(sizeValues).forEach(function (k) { sizeValues[k] = 0; var i = g('cc-size-' + k); if (i) i.value = 0; });
    }
    update();
  }

  // ── Intercept Add to Cart and inject properties via Cart AJAX API ──
  function interceptAddToCart() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      // Block if sizes not allocated
      if (alloc() !== selectedQty) {
        e.preventDefault(); e.stopImmediatePropagation(); update();
        var sec = document.querySelector('.cc-sizes-section');
        if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      // Get variant ID from form
      var variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return; // let form proceed normally

      e.preventDefault();
      e.stopImmediatePropagation();

      var variantId = parseInt(variantInput.value);
      var properties = buildProperties();

      // Show loading state
      var addBtn = form.querySelector('button[name="add"]');
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding...'; }

      // Add to cart via AJAX with properties
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: selectedQty,
          properties: properties
        })
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          alert(data.description || 'Could not add to cart. Please try again.');
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
          return;
        }
        // Success — trigger cart update and open drawer or redirect
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // Try to open cart drawer if it exists
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Fallback: update cart count and redirect to cart
          window.location.href = '/cart';
        }

        if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
        setCart(false); // reset after adding
      })
      .catch(function (err) {
        console.error('Cart add error:', err);
        alert('Something went wrong. Please try again.');
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
      });

      return false;
    }, true);

    // Also intercept Buy Now (dynamic checkout) buttons
    document.querySelectorAll('.shopify-payment-button__button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (alloc() !== selectedQty) {
          e.preventDefault(); e.stopImmediatePropagation(); update();
          var sec = document.querySelector('.cc-sizes-section');
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
        // Inject properties into the form before Buy Now submits
        var props = buildProperties();
        Object.keys(props).forEach(function (key) {
          var existing = form.querySelector('[name="properties[' + key + ']"]');
          if (existing) {
            existing.value = props[key];
          } else {
            var inp = document.createElement('input');
            inp.type = 'hidden';
            inp.name = 'properties[' + key + ']';
            inp.value = props[key];
            form.appendChild(inp);
          }
        });
      });
    });
  }

  function setUploadBtnSelected(btnId, filename) {
    var btn = g(btnId);
    if (!btn) return;
    var short = filename.length > 14 ? filename.substring(0, 12) + '…' : filename;
    btn.classList.add('cc-upload-btn--selected');
    btn.querySelector('.cc-upload-btn-icon').textContent = '✓';
    btn.querySelector('.cc-upload-btn-label').textContent = short;
  }

  function resetUploadBtn(btnId, label) {
    var btn = g(btnId);
    if (!btn) return;
    btn.classList.remove('cc-upload-btn--selected');
    btn.querySelector('.cc-upload-btn-icon').textContent = '+';
    btn.querySelector('.cc-upload-btn-label').textContent = label;
  }

  function init() {
    var cc = g('corporate-customizer');
    if (!cc) return;

    hideNative(); syncQty(5); setCart(false); update();
    interceptAddToCart();

    // Qty pills
    cc.querySelectorAll('.cc-qty-pill').forEach(function (p) {
      p.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); selQty(parseInt(this.dataset.qty)); });
    });

    // Custom qty
    var ci = g('cc-custom-qty');
    if (ci) ci.addEventListener('change', function (e) {
      e.stopPropagation();
      var v = parseInt(this.value);
      if (isNaN(v) || v < 5) v = 5;
      if (v % 5 !== 0) v = Math.ceil(v / 5) * 5;
      this.value = v; selQty(v);
    });

    // Size steppers
    cc.querySelectorAll('.cc-step-minus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var s = this.dataset.size;
        if (sizeValues[s] > 0) { sizeValues[s]--; var i = g('cc-size-' + s); if (i) i.value = sizeValues[s]; update(); }
      });
    });
    cc.querySelectorAll('.cc-step-plus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var s = this.dataset.size;
        if ((selectedQty - alloc()) > 0) { sizeValues[s]++; var i = g('cc-size-' + s); if (i) i.value = sizeValues[s]; update(); }
      });
    });

    // File uploads
    cc.querySelectorAll('.cc-file-input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var file = this.files[0];
        if (!file) return;
        if (['image/png','image/jpeg','image/svg+xml'].indexOf(file.type) === -1) { alert('PNG, JPG or SVG only.'); this.value = ''; return; }
        if (file.size > 5 * 1024 * 1024) { alert('Max 5MB.'); this.value = ''; return; }
        uploadedFiles[this.dataset.prop] = file.name;
        setUploadBtnSelected(this.dataset.btn, file.name);
      });
    });

    // Back text toggle
    var backTextBtn = g('cc-btn-back-text');
    var backTextPanel = g('cc-backtext-panel');
    if (backTextBtn && backTextPanel) {
      backTextBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var isOpen = backTextPanel.style.display !== 'none';
        if (isOpen) {
          backTextPanel.style.display = 'none';
          resetUploadBtn('cc-btn-back-text', 'Back Text');
          var inp = g('cc-back-text-input'); if (inp) inp.value = '';
        } else {
          backTextPanel.style.display = 'block';
          backTextBtn.classList.add('cc-upload-btn--active');
          var inp2 = g('cc-back-text-input'); if (inp2) inp2.focus();
        }
      });
    }

    // Back text live label update
    var bt = g('cc-back-text-input'), bc = g('cc-char-remaining');
    if (bt) {
      bt.addEventListener('input', function () {
        if (bc) bc.textContent = 30 - this.value.length;
        var btn = g('cc-btn-back-text');
        if (btn) {
          if (this.value.length > 0) {
            var short = this.value.length > 14 ? this.value.substring(0, 12) + '…' : this.value;
            btn.classList.add('cc-upload-btn--selected');
            btn.querySelector('.cc-upload-btn-icon').textContent = '✓';
            btn.querySelector('.cc-upload-btn-label').textContent = short;
          } else {
            resetUploadBtn('cc-btn-back-text', 'Back Text');
            btn.classList.add('cc-upload-btn--active');
          }
        }
      });
    }
  }

  function waitAndInit() {
    if (document.getElementById('corporate-customizer')) { init(); }
    else { requestAnimationFrame(waitAndInit); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', waitAndInit); }
  else { waitAndInit(); }

})();